import { useTranslator } from '@Localization';
import { ReactElement } from 'react';
import { IProjectActivity, IProjectActivityRemoveQuestionAnswer } from '../../projectDetailsActivities.models';
import { RenderRelatedAnnotationsCount } from './RenderRelatedAnnotationsCount2';

export const RemoveQuestionAnswerActivity = ({ values }: IProjectActivity<IProjectActivityRemoveQuestionAnswer>): ReactElement => {
  const { t } = useTranslator();
  return (
    <span>
      {t('activity_description_common.removeAnswer')}
      <b>{values.answer}</b> {t('activity_description_common.from')} {t('activity_description_common.question')} <b>{values.question}</b>
      <RenderRelatedAnnotationsCount
        strategy={values.strategy}
        count={values.updatedAnnotationsCount}
      />
      .
    </span>
  );
};
